module.exports = __webpack_public_path__ + "img/Dimitra_logo_white.bd008ba7.png";